import { useState } from 'react'
import { AvatarWrapper } from './style'
import { UserPopupModal } from '@/shared/ui/molecules/user-popup-modal'
import { useTheme } from '@/entities/theme/model'

interface User {
  imageUrl?: string
  fullname?: string
  [key: string]: unknown
}

interface AvatarProps {
  user: User
}

const Avatar = ({ user }: AvatarProps) => {
  const { theme } = useTheme()
  const [open, setOpen] = useState(false)

  return (
    <UserPopupModal src={user?.imageUrl} user={user} open={open} onOpenChange={setOpen}>
      <AvatarWrapper>
        {user?.imageUrl ? (
          <img src={user?.imageUrl} alt='avatar' />
        ) : (
          <AvatarWrapper.Avatar theme={theme}>
            {user?.fullname?.charAt(0)}
          </AvatarWrapper.Avatar>
        )}
      </AvatarWrapper>
    </UserPopupModal>
  )
}

export default Avatar
